import {
  StorageExclusionItemType,
  StorageProtectionExclusionItem,
  StorageProtectionExclusionItemFormValue,
} from '@nirvana/shared/dtos/types/policies/common';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { sanitizeHash } from './converters';
import { ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';

// validate hashes if type is hash
export function validateHashesIfNeeded(type: StorageExclusionItemType, path: string): ValidationResult {
  if (type === StorageExclusionItemType.HASH) {
    return validateHashes(path);
  }

  return { valid: true };
}

// validate hashes
export function validateHashes(stringOfHashes: string): ValidationResult {
  const hashes = sanitizeHash(stringOfHashes).split(',');
  const sha256Regex = /^[0-9A-Fa-f]{64}$/;

  // check for duplicates
  if (new Set(hashes).size !== hashes.length) {
    return {
      valid: false,
      error: translateFn('Duplicate values'),
    };
  }

  // check if all hashes are valid
  for (const hash of hashes) {
    if (!sha256Regex.test(hash)) {
      return {
        valid: false,
        error: translateFn('Hashes must be SHA256'),
      };
    }
  }

  return {
    valid: true,
  };
}

// validate type
export function validateType(type: number): ValidationResult {
  for (const exclusionType of Object.values(StorageExclusionItemType)) {
    if (type === exclusionType) {
      return {
        valid: true,
      };
    }
  }

  return {
    valid: false,
    error: '',
  };
}

// validate duplicates
export function validateDuplicates(
  exclusionItem: StorageProtectionExclusionItemFormValue,
  exclusionsInGrid: StorageProtectionExclusionItem[]
): ValidationResult {
  const exclusionPath = exclusionItem.path.toLowerCase();
  const hasDuplicates = exclusionsInGrid.some(
    (exclusionInGrid: StorageProtectionExclusionItem) =>
      exclusionInGrid.type === exclusionItem.type && exclusionInGrid.path.toLowerCase() === exclusionPath
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
